export const serviceConfig = {
  clerk: {
    publishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined,
  },
  convex: {
    url: import.meta.env.VITE_CONVEX_URL as string | undefined,
  },
};

export function isConfigured(value: string | undefined): boolean {
  return Boolean(value && value.trim().length > 0);
}
